import {ErrorHandler, Injectable, NgZone} from "@angular/core";
import * as Sentry from "@sentry/angular";
import {Router} from "@angular/router";
import {ErrorService} from "./service/error.service";
import {environment} from "../environments/environment";

@Injectable()
export class SentryErrorHandler implements ErrorHandler{

  constructor(private readonly router: Router, private readonly zone: NgZone, private readonly errorService: ErrorService) {

    const escapedApiUrl2 = environment.apiUrl2.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special regex characters
    const allowedApiUrl = new RegExp(`^${escapedApiUrl2}.*`);

    Sentry.init({
      dsn: "https://af28d9d08f634398a9d9726ec2caa0f9@o1036057.ingest.sentry.io/6003500",
      environment: environment.production ? 'production' : 'development',
      tracesSampleRate: 1.0,
      tracePropagationTargets:environment.production ?  [
        "https://api.connect.docestate.com",
      ] : [
        "https://api.connect.dev.docestate.com",
        /^http:\/\/localhost:\d+/],
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,

      integrations:[
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            mask: [], // explicitly allow everything
            unmask: ['input', 'textarea', '*'], // unmask all elements
            networkDetailAllowUrls: [allowedApiUrl, 'https://api.connect.docestate.com/api/user']
          })
      ],

      beforeSend(event,hint){
/*        if(event.exception){
          Sentry.showReportDialog({eventId: event.event_id});
        }*/
        return event;
      }
    })
  }

  handleError(error: any) {
    Sentry.captureException(error.originalException ?? error, scope =>{
      return scope;
    })
    //this.zone.run(() => this.errorService.openSnackBar())
  }

}

export function getErrorHandler(router:Router,zone:NgZone,errorService: ErrorService): ErrorHandler{
  return new SentryErrorHandler(router,zone,errorService);
}

